import axios from "axios";
import React from "react";
import constants from "../utilities/constants.json";
import { useDispatch } from "react-redux";
import { useSetUnderMaintenance } from "./useMaintenanceStatus";
import { SetWeekDay, UpdateWeekDays } from "../actions";

const apiUrl = constants.server + "weekly-list";

export default function useUpdateWeekDays() {
  const dispatch = useDispatch();
  const { setSiteUnderMaintenance } = useSetUnderMaintenance();

  React.useEffect(() => {
    const fetchWeekDays = async () => {
      try {
        const response = await axios.get(apiUrl);
        const data = response.data.status === 1 ? response.data.data : [];
        if (data?.length) {
          dispatch(UpdateWeekDays(data));
          dispatch(SetWeekDay(data[0]));
        } else {
          if (response.data.status === 103) {
            setSiteUnderMaintenance();
          } else if (response.data.status == 0 || response.data.status == 102) {
            localStorage.clear();
          }
        }
      } catch (error) {
        console.error("Error fetching week days:", error);
      }
    };

    fetchWeekDays();
  }, []);
}
